const config: siteConfig = {  
  API_URL: "http://localhost:9191/api",
  ENCRYPTION_KEY: "your-secret-key",
   REDIRECT_SESSION_KEY:""
};

export default config;
